import { isArrayNullOrEmpty } from 'app/common/utils/utils.array';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, forkJoin, map, of } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

export const TranslationGuard: (...scopes: string[]) => CanActivateFn =
	(...scopes: string[]) =>
	() => {
		if (isArrayNullOrEmpty(scopes)) {
			return of(true);
		}

		const translocoService = inject(TranslocoService);
		const loadTranslations$ = scopes.map(scope =>
			translocoService.load(
				`${scope}/${translocoService.getActiveLang()}`
			)
		);

		return forkJoin(loadTranslations$).pipe(
			map(() => true),
			catchError(() => of(false))
		);
	};
